<template>
  <v-app>
    <v-app-bar flat app class="custom-app-bar">
      <div class="d-flex align-center">
        <v-img
          alt="flybysms Logo"
          class="shrink mr-2"
          contain
          src="@/assets/flybysms.svg"
          transition="scale-transition"
          width="120"
        />
      </div>
    </v-app-bar>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="5">
          <v-card width="500" class="pa-4 custom-card" flat>
            <!-- Your card content goes here -->
            <v-form @submit.prevent="activate" v-model="isFormValid" ref="form">
              <div
                class="ml-4 mb-2 text-h6 text-md-h5 text-lg-h4 font-weight-bold font-theme"
              >
                Complete registration
              </div>
              <div class="ml-4 grey2--text mb-2">
                Please provide your username
              </div>
              <v-card-text class="pb-0">
                <div class="mb-1 subtitle-2 grey3--text">Username</div>
                <v-text-field
                  v-model="username"
                  placeholder="Username"
                  :rules="usernameRules"
                  filled
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-card-account-details"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">
                  Country(Auto filled)
                </div>
                <v-text-field
                  placeholder="Country"
                  v-model="country"
                  :disabled="true"
                  outlined
                  dense
                  class="mb-2"
                  prepend-inner-icon="mdi-map-marker"
                ></v-text-field>
                <v-btn
                  class="mt-2 primary white--text lowercase-text"
                  block
                  plain
                  :loading="$store.state.loading.registerCompleteBtn.load"
                  :disabled="$store.state.loading.registerCompleteBtn.disabled"
                  type="submit"
                  dark
                >
                  Submit
                </v-btn>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      isFormValid: false,
      usernameRules: [
        (v) => !!v || "Username is required",
        (v) => (v && v.length >= 3) || "Username must be at least 3 characters",
        (v) =>
          /^[a-zA-Z0-9_]+$/.test(v) ||
          "Username can only contain letters, numbers, and underscores",
      ],
      country: "Kenya",
    };
  },
  methods: {
    async activate() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("activate", {
          token: this.$route.params.token,
          values: {
            username: this.username,
            country: this.country,
          },
        });
        if (this.$store.state.user) {
          this.$router.push({ name: "dashboard" });
        }
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
